import React, { memo } from 'react'
import PropTypes from 'prop-types'

const AppLogo = ({ appCode, logoUrl }) => {
  return (
    <div className="topNav__branding">
      <div className="appAcronym">
        <div className="appAcronym__label"></div>
        {appCode}
      </div>

      <img src={logoUrl} className="iconic injectSVG appLogo" alt={`${appCode} Logo`} />
      <h1 className="appTitle">{appCode}</h1>
    </div>
  )
}

AppLogo.propTypes = {
  appCode: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
}

export default memo(AppLogo)
